import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { cityParser } from '@/plugins/city_parser'

@Component
export default class SkeletonFluid extends Vue {
  @Prop({ default: '#ECEBEB' }) superCategoriesParsed!: String
  @Prop({ default: 0 }) superCategoryId!: Number
  @Getter getIsUnderMobile: any
  @Getter getCity: any

  superCategories       = []
  superCategorySelected = {}

  get getParsedCity () {
    return cityParser(this.getCity.commercial_name)
  }

  async mounted() {
    // this._getSuperCategories()
  }
}
